import { z } from 'zod';

import { cuidLike } from '../zod-common';

export const matchScoreBreakdownInputSchema = z.object({
  offerId: cuidLike,
});
export type MatchScoreBreakdownInput = z.infer<typeof matchScoreBreakdownInputSchema>;

export const matchScoreComponentsSchema = z.object({
  language: z.number().min(0).max(100),
  skills: z.number().min(0).max(100),
  budget: z.number().min(0).max(100),
  type: z.number().min(0).max(100),
  history: z.number().min(0).max(100),
  freshness: z.number().min(0).max(100),
});
export type MatchScoreComponents = z.infer<typeof matchScoreComponentsSchema>;

export const matchScoreResultSchema = z.object({
  score: z.number().min(0).max(100),
  components: matchScoreComponentsSchema,
});
export type MatchScoreResult = z.infer<typeof matchScoreResultSchema>;

export const MATCH_SCORE_WEIGHTS = {
  language: 0.3,
  skills: 0.3,
  budget: 0.15,
  type: 0.1,
  history: 0.1,
  freshness: 0.05,
} as const satisfies Record<keyof MatchScoreComponents, number>;

export const PROFILE_SCORE_WEIGHTS = {
  competences: 0.35,
  coherence: 0.15,
  references: 0.05,
  langue: 0.25,
  historique: 0.2,
} as const;

export const LINGUISTIC_PREQUALIFICATION_THRESHOLD = 60;

export const profileScoreBreakdownInputSchema = z.object({
  bidId: cuidLike,
});
export type ProfileScoreBreakdownInput = z.infer<typeof profileScoreBreakdownInputSchema>;

export const profileScoreDimensionsSchema = z.object({
  competences: z.number().min(0).max(100),
  langue: z.number().min(0).max(100),
  historique: z.number().min(0).max(100),
  coherence: z.number().min(0).max(100),
  references: z.number().min(0).max(100),
});
export type ProfileScoreDimensions = z.infer<typeof profileScoreDimensionsSchema>;

export const profileScoreBreakdownResultSchema = z.object({
  profileScore: z.number().min(0).max(100).nullable(),
  dimensions: profileScoreDimensionsSchema.nullable(),
  iaSummary: z.string().nullable(),
  iaStrengths: z.array(z.string()).nullable(),
  iaConcerns: z.array(z.string()).nullable(),
  iaModel: z.string().nullable(),
  fallbackUsed: z.boolean(),
});
export type ProfileScoreBreakdownResult = z.infer<typeof profileScoreBreakdownResultSchema>;

export const PROFILE_SCORE_DIMENSION_ORDER = [
  'competences',
  'langue',
  'historique',
  'coherence',
  'references',
] as const satisfies ReadonlyArray<keyof ProfileScoreDimensions>;
